import { atom, useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import { useCallback } from 'react';
import { uuid } from 'global/utils/common';
import { ModalState, UseModal, ModalParams, UseCloseModal } from './modal.types';

export const modalsState = atom<ModalState>({
  default: {
    active: undefined,
    instances: [],
  },
  key: 'modalsState',
});

export const useCloseModal = (): UseCloseModal => {
  const setState = useSetRecoilState(modalsState);

  const closeModal = useCallback((id: string) => {
    setState(state => ({ active: undefined, instances: state.instances.filter(item => item.id !== id) }));
  }, []);

  return {
    closeModal,
  };
};

export const useModalsState = (): ModalState => useRecoilValue(modalsState);

export const useModal = (instance: ModalParams): UseModal => {
  const setState = useSetRecoilState(modalsState);
  const reset = useResetRecoilState(modalsState);

  const showModal = useCallback((options: object & ModalParams = {}) => {
    setState(state => {
      const id = uuid();
      return { active: id, instances: [...state.instances, { ...instance, ...options, id }] };
    });
  }, []);

  return {
    reset,
    showModal,
  };
};
